import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatDate(dateStr) {
  const date = new Date(dateStr);

  const month = date
    .toLocaleString("default", { month: "short" })
    .toUpperCase();

  const day = date.getDate();
  const year = date.getFullYear();

  return { month, day, year };
}

function LatestNewSection({ datacontent, initialPagination, id }) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewsList(datacontent || []);

    setSelectedNews(datacontent?.[0] || null);
  }, [datacontent]);

  useEffect(() => {
    //if (page === 1) return;

    fetchNews();
  }, [page]);

  const fetchNews = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}posdata?pageName[eq]=${id}&columes[eq]=title_show_echo_01zz&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&page=${page}&per_page=3`);

      const allData = response?.data?.allData || [];

      setNewsList(allData);

      // auto select first news
      setSelectedNews(allData[0] || null);

      setPagination(
        response?.data?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const { month, day, year } = selectedNews?.daterqw
    ? formatDate(selectedNews.daterqw)
    : { month: "", day: "", year: "" };

  if (!selectedNews) return null;

  return (
    <section
      id="about"
      className="about section" 
    >
      <div className="container section-title" data-aos="fade-up">
        <h2>LATEST NEWS</h2>
        <p>
          <span>Top Stories</span>{" "}
          <span className="description-title">That Matter</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-3">
          {/* Main News */}
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
            {selectedNews.passport && (
              <>
                <div className="position-relative mb-2">
                  {selectedNews.passport &&
                    selectedNews.passport !== "undefined" &&
                    selectedNews.passport !== "null" &&
                    selectedNews.passport.trim() !== "" && (
                      <>
                        <img
                          loading="lazy"
                          decoding="async"
                          src={`${BACKEND_URL}upload/${selectedNews.passport}`}
                          alt={selectedNews.title || "Image"}
                          className="img-fluid"
                          style={{ objectFit: "cover", height: "470px" }}
                        />
                      </>
                    )}

                  <div className="vertical-date-badge">
                    <div className="date-part">{month}</div>
                    <div className="date-divider">—</div>
                    <div className="date-part vertical-formatDate">{day}</div>
                    <div className="date-divider">—</div>
                    <div className="date-part">{year}</div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Summary + Thumbnails */}
          <div
            className="col-lg-6 d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay={200}
          >
            <div className="row">
              <div className="col-lg-12">
                <div className="about-content ps-0 ps-lg-3">
                  <span
                    className="text-capitalize text-secondary"
                    style={{ textAlign: "justify" }}
                  >
                    <HTMLDisplay
                      html={selectedNews.story01}
                      textNo={18}
                      type="title"
                    />
                  </span>

                  <p
                    style={{ textAlign: "justify" }}
                    className="text-secondary"
                  >
                    <HTMLDisplay
                      html={selectedNews.story01}
                      textNo={70}
                      type="body"
                    />
                    <br />
                  </p>

                  <Link
                    to={`/read/${selectedNews.id}`}
                    className="read-more-link btn btn-iceberg mb-3 mt-auto"
                  >
                    Read More →
                  </Link>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="row">
                  {newsList?.map((item, index) => {
                    const date = new Date(item.daterqw);

                    const month = date
                      .toLocaleString("default", { month: "short" })
                      .toUpperCase();

                    const day = date.getDate();
                    const year = date.getFullYear();

                    return (
                      <div className="col-lg-4 col-md-6" key={item.id || index}>
                        <div
                          className="position-relative mb-2 hoverable"
                          onClick={() => setSelectedNews(item)}
                          style={{ cursor: "pointer" }}
                        >
                          {item.passport &&
                            item.passport !== "undefined" &&
                            item.passport !== "null" &&
                            item.passport.trim() !== "" && (
                              <>
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  src={`${BACKEND_URL}upload/${item.passport}`}
                                  alt={item.title || "Image"}
                                  className="img-fluid"
                                  style={{
                                    objectFit: "cover",
                                    height: "130px",
                                    width: "100%",
                                  }}
                                />

                                <div
                                  className="vertical-date-badge"
                                  style={{ fontSize: "0.65rem" }}
                                >
                                  <div className="date-part">{month}</div>
                                  <div className="date-divider">—</div>
                                  <div className="date-part">{day}</div>
                                  <div className="date-divider">—</div>
                                  <div className="date-part">{year}</div>
                                </div>
                              </>
                            )}

                          {/* Hover preview modal effect */}
                          <div
                            className="hover-summary position-absolute bottom-0 start-0 w-100 bg-success text-white p-1"
                            style={{
                              fontSize: "0.8rem",
                              display: "none",
                              opacity: "0.85",
                            }}
                          >
                            <p className="m-0 p-1 text-capitalize text-white">
                              <HTMLDisplay
                                html={item.story01}
                                textNo={13}
                                type="title"
                                textSize="0.8rem"
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <button
                    className="btn btn-dark me-2"
                    onClick={() => setPage(1)}
                    disabled={pagination?.current_page === 1}
                  >
                    «
                  </button>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() => setPage(pagination?.current_page - 1)}
                    disabled={pagination?.current_page === 1}
                  >
                    ‹
                  </button>

                  <span className="me-2">
                    Page {pagination?.current_page} of {pagination?.last_page}
                  </span>

                  <button
                    className="btn btn-dark me-2"
                    onClick={() => setPage(pagination?.current_page + 1)}
                    disabled={
                      pagination?.current_page === pagination?.last_page
                    }
                  >
                    ›
                  </button>

                  <button
                    className="btn btn-dark"
                    onClick={() => setPage(pagination?.last_page)}
                    disabled={
                      pagination?.current_page === pagination?.last_page
                    }
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(LatestNewSection);
